import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class AnniversaryBonus extends DomainObject {
  @observable id;
  @observable anniversary;
  @observable rateAdjustment;
  @observable effectiveRate;
}

export default AnniversaryBonus;

